function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "doc",
  transform: "translate(-3.000000, 0.000000)",
  fill: "#3B3A42",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(2.999814, 0.000000)"
}, React.createElement("path", {
  d: "M14.0001862,1.99996146 L2.26953018,1.99970607 C2.11564481,2.00343796 1.9979018,2.12484409 2.00028624,2.283 L2.00028624,25.7225 L2.00015956,25.7439169 C1.99800586,25.8792085 2.10988227,25.9951282 2.25597825,26.0000001 L19.7282674,26.0001448 C19.8837103,25.997499 20.0026687,25.8758548 20.0002862,25.717 L20.0002862,7.99996208 L16.8319659,7.99984193 C15.3476012,8.02623754 14.0955493,6.90212202 14.0001862,5.372 L14.0001862,1.99996146 Z M15.9994352,2.60253825 L15.998167,5.30848235 C16.0228666,5.69655988 16.3694735,6.00774998 16.8141862,6 L19.5531802,6 L15.9994352,2.60253825 Z M2.24528624,28 L2.22955142,27.9998762 C0.980739481,27.9802239 -0.0194186254,26.9578648 0.000286238733,25.728 L0.000286238733,25.717 L0.00041219125,2.29887102 C-0.0193407712,1.05443438 0.973656,0.0305443798 2.24528624,0 L16.1713923,0 L22.0002862,5.57255633 L22.0002862,6 L22.0001617,25.70122 C22.0199089,26.9524741 21.0165297,27.9785067 19.7452862,28 L2.24528624,28 Z",
  id: "Combined-Shape"
}), React.createElement("polygon", {
  id: "Stroke-5",
  points: "4.00018624 7 12.0001862 7 12.0001862 5 4.00018624 5"
}), React.createElement("polygon", {
  id: "Stroke-7",
  points: "4.00018624 11 18.0001862 11 18.0001862 9 4.00018624 9"
}), React.createElement("polygon", {
  id: "Stroke-9",
  points: "4.00018624 15 18.0001862 15 18.0001862 13 4.00018624 13"
}), React.createElement("polygon", {
  id: "Stroke-11",
  points: "4.00018624 19 18.0001862 19 18.0001862 17 4.00018624 17"
}), React.createElement("polygon", {
  id: "Stroke-13",
  points: "4.00018624 23 18.0001862 23 18.0001862 21 4.00018624 21"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "22px",
    height: "28px",
    viewBox: "0 0 22 28",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/doc.163af5ef.svg";
export { SvgComponent as ReactComponent };